import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import {environment} from '../../../../../environments/environment';
import {Feedback} from '../../interfaces/Feedback';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';


@Injectable()
export class ComplimentService {

  private route = 'compliment';
  private fileRoute = 'compliment/file';
  private downloadroute = 'compliment/download';

  constructor(private http: AuthHttp) {
  }

  public getComplaint(limit: number = 10, page = 1, id) {
    return this.http.get(`${environment.baseUrl}${this.route}?limit=${limit}&page=${page}&flightId=${id}`)
      .map((res) => res.json()).toPromise();
  }

  public create(feedback: Feedback) {
    return this.http.post(`${environment.baseUrl}${this.route}`, this.createFormData(feedback))
      .map(res => res.json()).toPromise();

  }

  public update(feedback: Feedback) {
    return this.http.put(`${environment.baseUrl}${this.route}/${feedback.id}`,
      feedback).map((res) => res.json()).toPromise();
  }

  public delete(id) {
    return this.http.delete(`${environment.baseUrl}${this.route}/${id}`).map((res) => res.json()).toPromise();
  }

  public fileDelete(id) {
    console.log('passed');
    return this.http.delete(`${environment.baseUrl}${this.fileRoute}/${id}`).map((res) => res.json()).toPromise();
  }

  public getDownloadUrl(id) {
    return encodeURI(`${environment.baseUrl}${this.downloadroute}/${id}?token=${this.http.getTokenBearer()}`);
  }

  public edit(feedback: Feedback) {

    return this.http.post(`${environment.baseUrl}${this.route}/${feedback.id}`,
      this.createFormData(feedback))
      .map(res => res.json()).toPromise();
  }

  protected createFormData(request: any) {

    const formData: FormData = new FormData();
    for (const key in request) {
      if (request.hasOwnProperty(key)) {
        if (request[key] && request[key].constructor === File) {
          formData.append(key, request[key], request[key].name);
        } else
          formData.append(key, request[key]);
      }
    }
    return formData;
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-renderer/services/feedback/compliment.service.ts